var _path, _g, _circle, _circle2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShadowWaveImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 938,
    height: 382,
    viewBox: "0 0 938 382",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 315C2 315 133.575 357.84 231 298.5C304.5 253.732 299.5 189.5 364.5 145C535.624 27.8459 598.421 210.944 749 195C876.5 181.5 941.5 1 941.5 1",
    stroke: "url(#paint0_linear_4068_57)",
    strokeWidth: 3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter0_f_4068_57)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 355C11 355 142.575 397.84 240 338.5C313.5 293.732 308.5 229.5 373.5 185C544.624 67.8459 607.421 250.944 758 235C885.5 221.5 950.5 41 950.5 41",
    stroke: "url(#paint1_linear_4068_57)",
    strokeWidth: 3
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 295.09,
    cy: 229.09,
    r: 17.5901,
    stroke: "#3C73FF",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 295.652,
    cy: 229.652,
    r: 4.6762,
    fill: "white",
    stroke: "#3C73FF",
    strokeWidth: 3
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_4068_57",
    x: 0.537842,
    y: 30.4929,
    width: 961.372,
    height: 350.961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect1_foregroundBlur_4068_57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4068_57",
    x1: 7.5,
    y1: 318,
    x2: 942,
    y2: 318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C73FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3C73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3C73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C73FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4068_57",
    x1: 16.5,
    y1: 358,
    x2: 951,
    y2: 358,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C73FF",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#3C73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#3C73FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C73FF",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadowWaveImage);
export default __webpack_public_path__ + "static/media/ShadowWaveImage.c6b1b60fd4ec63393e5a238af69fd800.svg";
export { ForwardRef as ReactComponent };